import {FC} from 'react';

import {Typography} from '@mui/material';

import {StyledBasketPromotionBanner} from '../styled';

export interface BasketShippingFeePromotionBannerProps {
  message: string;
}

export const BasketShippingFeePromotionBanner: FC<BasketShippingFeePromotionBannerProps> = ({message}) => {
  if (!message) {
    return null;
  }
  return (
    <StyledBasketPromotionBanner>
      <Typography
        component={'p'}
        variant="body2"
        color="common.mds_global_color_purple"
        dangerouslySetInnerHTML={{__html: message}}
      />
    </StyledBasketPromotionBanner>
  );
};

BasketShippingFeePromotionBanner.displayName = 'BasketShippingFeePromotionBanner';
